import { AbstractModel, JsonObject, JsonProperty } from 'projects/core/src/public-api';

export type TimeCardType = 'WORK' | 'PAID_BREAK' | 'UNPAID_BREAK';

@JsonObject('model.cv.Vendor')
export class Vendor extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'address1')
    address1?: string;

    @JsonProperty(String, 'address2')
    address2?: string;

    @JsonProperty(String, 'city')
    city?: string;

    @JsonProperty(String, 'state')
    state?: string;

    @JsonProperty(String, 'zipCode')
    zipCode?: string;

    @JsonProperty(String, 'country')
    country?: string;

    @JsonProperty(String, 'phone')
    phone?: string;

    @JsonProperty(String, 'mobilePhone')
    mobilePhone?: string;

    @JsonProperty(String, 'eMail')
    eMail?: string;

}